module.exports = __webpack_public_path__ + "static/media/tz.da263ef1.svg";